import { render, staticRenderFns } from "./SalaryList.vue?vue&type=template&id=4d29b668&scoped=true&"
import script from "./SalaryList.vue?vue&type=script&lang=js&"
export * from "./SalaryList.vue?vue&type=script&lang=js&"
import style0 from "./SalaryList.vue?vue&type=style&index=0&id=4d29b668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d29b668",
  null
  
)

export default component.exports